module.exports = __webpack_public_path__ + "img/6.fe67c38d.png";